(function ($) {

    $(document).ready(function () {

        // --- Filtres sticky / fixed selon body.hide-nav ---
        document.querySelectorAll('.listanimal-filtres').forEach(function (filtres) {
            var sentinel = document.createElement('div');
            filtres.parentElement.insertBefore(sentinel, filtres);

            var observer = new IntersectionObserver(function (entries) {
                filtres.classList.toggle('is-stuck', !entries[0].isIntersecting);

            }, { threshold: 0 });

            observer.observe(sentinel);
        });

        // --- Toggle mobile filtres ---
        $('.bloc-listanimal').on('click', '.filtres-toggle', function (e) {
            e.stopPropagation();
            var $toggle = $(this);
            var $panel  = $toggle.closest('.listanimal-filtres').find('.filtres-panel');
            var isOpen  = $toggle.hasClass('is-open');

            $toggle.toggleClass('is-open', !isOpen).attr('aria-expanded', !isOpen);
            $panel.toggleClass('is-open', !isOpen)
                  .find('.filtre-dropdown').toggleClass('is-open', !isOpen);
            $('body').toggleClass('filtres-open', !isOpen);
        });

        $(document).on('click.listanimal-filtres-mobile', function () {
            $('.filtres-toggle.is-open').removeClass('is-open').attr('aria-expanded', 'false');
            $('.filtres-panel.is-open').removeClass('is-open');
            $('body').removeClass('filtres-open');
        });

        // --- Dropdowns filtres ---
        function closeAllDropdowns() {
            $('.filtre-dropdown.is-open').removeClass('is-open')
                .find('.trigger').attr('aria-expanded', 'false');
        }

        $('.bloc-listanimal').on('click', '.filtre-dropdown .trigger', function (e) {
            e.stopPropagation();
            var $dropdown = $(this).closest('.filtre-dropdown');
            var isOpen    = $dropdown.hasClass('is-open');

            closeAllDropdowns();
            if (!isOpen) {
                $dropdown.addClass('is-open');
                $(this).attr('aria-expanded', 'true');
            }
        });

        $(document).on('click.listanimal-dropdown', function () {
            closeAllDropdowns();
        });

        // --- Filtres : rechargement AJAX ---
        function filterAnimals($wrapper) {
            var activeTypeAnimal   = $wrapper.find('[data-taxonomy="type-animal"].is-active').data('term') || '';
            var activeEtatAdoption = $wrapper.find('[data-taxonomy="etat-adoption"].is-active[data-term!=""]')
                .map(function () { return $(this).data('term'); }).get();
            var activeSexe         = $wrapper.find('[data-taxonomy="sexe"].is-active').data('term') || '';
            var $grid              = $wrapper.find('.listanimal-grid');
            var $loadmoreWrapper   = $wrapper.find('.listanimal-loadmore-wrapper');
            var $btn               = $wrapper.find('.listanimal-loadmore');

            window.scrollTo({ top: $wrapper.offset().top - 150, behavior: 'smooth' });
            $grid.css('opacity', 0.5);

            $.post(blockData.ajax_url, {
                action:        'cdm_listanimal_filter',
                type_animal:   activeTypeAnimal,
                etat_adoption: activeEtatAdoption,
                sexe:          activeSexe,
            }, function (response) {
                if (!response.success) return;

                $grid.html(response.data.html).css('opacity', 1);
                $wrapper.find('.listanimal-summary').text(response.data.summary);

                $btn.data('page', 1)
                    .data('total', response.data.total)
                    .data('per-page', response.data.per_page)
                    .data('type-animal', activeTypeAnimal)
                    .data('etat-adoption', activeEtatAdoption)
                    .data('sexe', activeSexe);

                if (response.data.has_more) {
                    $loadmoreWrapper.show();
                    initLoadMoreObserver($btn);
                } else {
                    $loadmoreWrapper.hide();
                }
            }, 'json');
        }

        $('.bloc-listanimal').on('click', '.filtre-option', function () {
            var $opt      = $(this);
            var $wrapper  = $opt.closest('.bloc-listanimal');
            var $dropdown = $opt.closest('.filtre-dropdown');
            var $trigger  = $dropdown.find('.trigger');
            var $menu     = $opt.closest('.menu');
            var taxonomy  = $opt.data('taxonomy');
            var term      = $opt.data('term');

            if (taxonomy === 'etat-adoption') {
                if (term === '') {
                    $menu.find('.filtre-option').removeClass('is-active');
                    $opt.addClass('is-active');
                } else {
                    $menu.find('[data-term=""]').removeClass('is-active');
                    $opt.toggleClass('is-active');
                    if ($menu.find('.filtre-option.is-active').length === 0) {
                        $menu.find('[data-term=""]').addClass('is-active');
                    }
                }
                var $actifs = $menu.find('.filtre-option.is-active[data-term!=""]');
                var label = $actifs.length > 0
                    ? $trigger.data('label') + ' (' + $actifs.length + ')'
                    : $trigger.data('label');
            } else {
                $menu.find('.filtre-option').removeClass('is-active');
                $opt.addClass('is-active');
                var count = term === '' ? 0 : 1;
                var label = count > 0
                    ? $trigger.data('label') + ' (1)'
                    : $trigger.data('label');
            }

            $trigger.find('.label').text(label);
            filterAnimals($wrapper);
        });

        // --- Load more déclenché par IntersectionObserver ---
        function initLoadMoreObserver($btn) {
            var observer = new IntersectionObserver(function (entries, obs) {
                if (!entries[0].isIntersecting) return;
                if ($btn.hasClass('is-loading')) return;

                obs.disconnect();
                triggerLoadMore($btn, function () {
                    // Réobserve si il reste encore des pages
                    if ($btn.length) {
                        initLoadMoreObserver($btn);
                    }
                });
            }, { threshold: 0.5 });

            observer.observe($btn[0]);
        }

        function triggerLoadMore($btn, onDone) {
            var $wrapper     = $btn.closest('.bloc-listanimal');
            var currentPage  = parseInt($btn.data('page'));
            var total        = parseInt($btn.data('total'));
            var perPage      = parseInt($btn.data('per-page'));
            var etatAdoption  = $btn.data('etat-adoption')   || '';
            var anneeAdoption = $btn.data('annee-adoption')  || '';
            var typeAnimal    = $btn.data('type-animal')     || '';
            var sexe          = $btn.data('sexe')            || '';
            var nextPage      = currentPage + 1;

            $btn.addClass('is-loading').prop('disabled', true);

            $.post(blockData.ajax_url, {
                action:          'cdm_listanimal_loadmore',
                page:            nextPage,
                per_page:        perPage,
                etat_adoption:   etatAdoption,
                annee_adoption:  anneeAdoption,
                type_animal:     typeAnimal,
                sexe:            sexe,
            }, function (response) {
                if (response.success && response.data.html) {
                    $wrapper.find('.listanimal-grid').append(response.data.html);
                    $btn.data('page', nextPage);

                    var loaded = nextPage * perPage;
                    if (loaded >= total) {
                        $btn.closest('.listanimal-loadmore-wrapper').remove();
                        $btn = $();
                    }
                }
            }, 'json').always(function () {
                $btn.removeClass('is-loading').prop('disabled', false);
                if (typeof onDone === 'function') onDone();
            });
        }

        // Init sur chaque bloc présent dans la page
        $('.listanimal-loadmore').each(function () {
            initLoadMoreObserver($(this));
        });

    });

})(jQuery);
